import React from "react";
import { render } from "react-dom";
import ModalCart from "./ModalCart";

const renderModalCart = () => {
  const body = document.querySelector("body");
  let root = document.querySelector(".js_modal_cart_root");
  
  if (!root) {
    root = document.createElement("div");
    root.classList.add("js_modal_cart_root");
    root && render(<ModalCart />, root);
    body.appendChild(root);
  }
};
export default renderModalCart;


// import React from "react";
// import ModalCart from "./ModalCart";
// import { createRoot } from "react-dom/client";

// const renderModalCart = () => {
//   const body = document.querySelector("body");
//   let cartContainer = document.querySelector(".js_modal_cart_root");
  
//   if (!cartContainer) {
//     cartContainer = document.createElement("div");
//     cartContainer.classList.add("js_modal_cart_root");
//     if (cartContainer) {
//       const root = createRoot(cartContainer)
//       root.render(<ModalCart />);
//     }
    
//     // root && render(<ModalCart />, root);
//     body.appendChild(cartContainer);
//   }
// };
// export default renderModalCart;
